'use client';

import { Button } from '@usitsdasdesign/dds-react';
import Heading from 'atoms/Heading';
import Text from 'atoms/Text';
import { useRouter } from 'hooks/navigation-router-with-loading';
import Image from 'molecules/Image';
import { signOut, useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { dumpLog } from 'services/dump-logs.service';
import Link from 'next/link';

function NotFound({
    title = 'Something went wrong!',
    description = 'Try to reload the page or visit the homepage using the button below',
    className = "bg-white",
    btnLink = '/',
    fromAvlReport = false,
    error, resetErrorBoundary,
    heading = '',
    iconSrc = '/images/404-not-found.svg',
    iconWidth = 64,
    iconHeight = 64,
    iconAlt = '404 Not found',
    isShowIcon = false,
    ctaLabel = 'Go to Home',
    onClick = () => false,
    showBtn = true
}) {
    const router = useRouter();
    const session = useSession();

    useEffect(() => {
        if (error) {
            const body = {
                logMessage: 'UIError: Error occured in the component',
                logData: {
                    errorStack: error.stack,
                    message: error.message, path: window.location.href,
                    resourceId: session?.data?.user?.resourceId
                }
            }
            dumpLog(body);
        }
    }, [])

    return (
        <div className={`w-screen h-screen bg-neutral-100 flex flex-col justify-center items-center ${className}`}>
            {
                isShowIcon
                && <Image src={iconSrc} width={iconWidth} height={iconHeight} alt={iconAlt} objectFit='contain' />
            }
            {heading && <Heading type="h2" className="text-red-900">{heading}</Heading>}
            <div className="mt-3 mb-7 text-center">
                <Heading type="h4">{title}</Heading>
                {/* {showBtn && <Text>{description}</Text>} */}
                {fromAvlReport ? null : <Text>Please contact admin for more information</Text>}
            </div>
            {showBtn && <div className='flex items-center gap-4'>
                {
                    fromAvlReport ?
                        <Link href={btnLink}>
                            <Button
                                label={ctaLabel}
                                size='m'
                                ariaLabel={ctaLabel} />
                        </Link>
                        :
                        <a href={btnLink}>
                            <Button
                                label={ctaLabel}
                                size='m'
                                onClick={onClick}
                                ariaLabel={ctaLabel} />
                        </a>
                }
                {/* <Button
                    label={'Go back'}
                    size='m'
                    onClick={() => {
                        if (window.history?.length && window.history.length > 1) {
                            router.back();
                        } else {
                            window.close();
                        }
                    }} /> */}
            </div>}
        </div>
    );
}

export default NotFound;
